import { observable } from "mobx";
import DistributorRefundCandidateApprovalRejectionReason from "./distributorRefundCandidateApprovalRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundApprovalPermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: DistributorRefundCandidateApprovalRejectionReason;
}
